import { render, staticRenderFns } from "./SingleSelectBox.vue?vue&type=template&id=3cbbbb72&scoped=true"
import script from "./SingleSelectBox.vue?vue&type=script&lang=js"
export * from "./SingleSelectBox.vue?vue&type=script&lang=js"
import style0 from "./SingleSelectBox.vue?vue&type=style&index=0&id=3cbbbb72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbbbb72",
  null
  
)

export default component.exports